var _defs, _polygon, _path, _path2, _path3, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasicInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148 138.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5- \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u067E\u0627\u06CC\u0647") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.165 109.193 128.165 109.214 86.013 109.336 86.013 109.193 128.165 109.193"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.23616,25.27231v.20409l-.01018,8.66571H77.0007a5.19443,5.19443,0,0,0-5.17748,5.19529v70.03978l-65.58789.18372A6.24675,6.24675,0,0,1,0,103.30406V6.25684A6.24675,6.24675,0,0,1,6.23533,0H28.89818A6.25065,6.25065,0,0,1,34.635,3.78672l4.39423,10.309a6.25248,6.25248,0,0,0,5.64541,3.79693l77.40754,1.1228A6.24985,6.24985,0,0,1,128.23616,25.27231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.01292,109.19347v.14291l42.152-.12248v-.02043Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.90849,39.24557H77.0007a.09132.09132,0,0,0-.09157.09183v99.19071a.09138.09138,0,0,0,.09157.09189h70.90779A.09133.09133,0,0,0,148,138.52811V39.3374A.09127.09127,0,0,0,147.90849,39.24557Zm-27.20962,7.88992h18.177v5.10345h-18.177ZM85.53487,58.608h53.341v5.10345h-53.341Zm-.03054,12.33h53.341v5.10345h-53.341Zm.03054,12.9117h53.341v5.10345h-53.341ZM139.12,127.89253H85.779v-5.10346H139.12Zm.23393-13.59561h-53.341v-5.10345h53.341Zm0-13.00359h-53.341V96.18988h53.341Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.165 109.193 128.165 109.214 86.013 109.336 86.013 109.193 128.165 109.193"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicInformation);
export default __webpack_public_path__ + "static/media/BasicInformation.e02d5108f482d34fa255d7b6d16215f7.svg";
export { ForwardRef as ReactComponent };